/*
Nav item for eg villa region
*/

import React from "react";
import { Link } from "gatsby";

const SimpleItem = ({ title, to }) => {
  return (
    <li className="nav-item">
      <Link to={to} className="nav-link black">
        {title}
      </Link>
    </li>
  );
};

export default SimpleItem;
